module.exports = __webpack_public_path__ + "img/img4.20fe627a.jpg";